import { render, staticRenderFns } from "./sms-verification-block.vue?vue&type=template&id=0cb6dbeb"
import script from "./sms-verification-block.vue?vue&type=script&lang=js"
export * from "./sms-verification-block.vue?vue&type=script&lang=js"
import style0 from "./sms-verification-block.vue?vue&type=style&index=0&id=0cb6dbeb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports